import Vue from "vue";

Vue.prototype.$globalData = {
    structure: [
        { label: '公司', value: '-1' },
        { label: '专区', value: '0' },
        { label: '模块', value: '1' },
        { label: '栏目', value: '2' },
        { label: '领域', value: '4' },
        { label: '子栏目', value: '5' },
    ]
}

Object.keys(Vue.prototype.$globalData).forEach(key => {
    Vue.filter(key, function(val) {
        return Vue.prototype.$globalData[key].find(f => f.value === val).label
    })
})


// WEBPACK FOOTER //
// ./src/utils/globalData.js